/** Détecte une préférence NL côté page hôte (lang document ou navigator). */
export function hostPrefersDutch(): boolean {
  try {
    const docLang = String(document.documentElement?.lang || '')
      .trim()
      .toLowerCase();
    if (docLang.startsWith('nl')) return true;
  } catch {
    /* ignore */
  }
  if (typeof navigator === 'undefined') return false;
  const tags =
    navigator.languages && navigator.languages.length > 0
      ? navigator.languages
      : [navigator.language];
  return tags.some((tag) => String(tag || '').toLowerCase().startsWith('nl'));
}
